module.exports = __webpack_public_path__ + "images/interview-TIkTok-2.svg";